export const iranCustoms = [
  { ctmVCodeInt: 10000, ctmNameStr: "Service Exports", ctmCodeStr: "0" },
  { ctmVCodeInt: 10101, ctmNameStr: "Mehrabad Commercial", ctmCodeStr: "8" },
  {
    ctmVCodeInt: 10102,
    ctmNameStr: "Payam Special Economic Zone",
    ctmCodeStr: "148",
  },
  { ctmVCodeInt: 10103, ctmNameStr: "Imam Khomeini Airport", ctmCodeStr: "77" },
  { ctmVCodeInt: 10105, ctmNameStr: "Passenger Zone 4", ctmCodeStr: "0" },
  {
    ctmVCodeInt: 10110,
    ctmNameStr: "Free Trade Zone Imam Khomeini Airport",
    ctmCodeStr: "53",
  },
  { ctmVCodeInt: 10200, ctmNameStr: "West Tehran", ctmCodeStr: "119" },
  { ctmVCodeInt: 10300, ctmNameStr: "Tehran", ctmCodeStr: "126" },
  {
    ctmVCodeInt: 10400,
    ctmNameStr: "Zone 3 of Postal Services",
    ctmCodeStr: "30",
  },
  {
    ctmVCodeInt: 10500,
    ctmNameStr: "Tehran Legal Department",
    ctmCodeStr: "182",
  },
  { ctmVCodeInt: 10600, ctmNameStr: "Exhibition", ctmCodeStr: "39" },
  { ctmVCodeInt: 10800, ctmNameStr: "Shahrekord", ctmCodeStr: "15" },
  { ctmVCodeInt: 10801, ctmNameStr: "Boroujen", ctmCodeStr: "76" },
  { ctmVCodeInt: 15100, ctmNameStr: "Isfahan", ctmCodeStr: "64" },
  { ctmVCodeInt: 15101, ctmNameStr: "Zob Ahan", ctmCodeStr: "91" },
  { ctmVCodeInt: 15102, ctmNameStr: "Mobarakeh Steel", ctmCodeStr: "133" },
  { ctmVCodeInt: 15103, ctmNameStr: "Isfahan Airport", ctmCodeStr: "20" },
  {
    ctmVCodeInt: 15104,
    ctmNameStr: "Isfahan Customs Evaluation at Darkashan",
    ctmCodeStr: "146",
  },
  { ctmVCodeInt: 15200, ctmNameStr: "Arak", ctmCodeStr: "125" },
  { ctmVCodeInt: 15201, ctmNameStr: "Saveh", ctmCodeStr: "34" },
  {
    ctmVCodeInt: 15202,
    ctmNameStr: "Kaveh Special Economic Zone",
    ctmCodeStr: "0",
  },
  {
    ctmVCodeInt: 15203,
    ctmNameStr: "Iranian Special Economic Zone (Zarandieh)",
    ctmCodeStr: "0",
  },
  { ctmVCodeInt: 15300, ctmNameStr: "Qazvin", ctmCodeStr: "109" },
  { ctmVCodeInt: 15400, ctmNameStr: "Semnan", ctmCodeStr: "151" },
  {
    ctmVCodeInt: 15401,
    ctmNameStr: "Garmsar Special Zone",
    ctmCodeStr: "15401",
  },
  {
    ctmVCodeInt: 15402,
    ctmNameStr: "Semnan Special Economic Zone",
    ctmCodeStr: "15402",
  },
  { ctmVCodeInt: 15500, ctmNameStr: "Hamedan", ctmCodeStr: "3" },
  { ctmVCodeInt: 15501, ctmNameStr: "Khorramabad", ctmCodeStr: "97" },
  {
    ctmVCodeInt: 15502,
    ctmNameStr: "Lorestan (Azna) Special Economic Zone",
    ctmCodeStr: "21",
  },
  { ctmVCodeInt: 15503, ctmNameStr: "Malayer", ctmCodeStr: "0" },
  { ctmVCodeInt: 15505, ctmNameStr: "Yasuj", ctmCodeStr: "123" },
  {
    ctmVCodeInt: 20100,
    ctmNameStr: "Anzali Free Trade Zone",
    ctmCodeStr: "175",
  },
  { ctmVCodeInt: 20200, ctmNameStr: "Astara", ctmCodeStr: "102" },
  { ctmVCodeInt: 20202, ctmNameStr: "Astara Export Terminal", ctmCodeStr: "0" },
  { ctmVCodeInt: 20300, ctmNameStr: "Bandar Nowshahr", ctmCodeStr: "5" },
  { ctmVCodeInt: 20302, ctmNameStr: "Fereydun Kenar", ctmCodeStr: "139" },
  { ctmVCodeInt: 20303, ctmNameStr: "Sari", ctmCodeStr: "92" },
  {
    ctmVCodeInt: 20304,
    ctmNameStr: "Amirabad Special Economic Zone",
    ctmCodeStr: "24",
  },
  { ctmVCodeInt: 20305, ctmNameStr: "Amol", ctmCodeStr: "0" },
  {
    ctmVCodeInt: 20306,
    ctmNameStr: "Nowshahr Special Economic Zone",
    ctmCodeStr: "0",
  },
  { ctmVCodeInt: 20400, ctmNameStr: "Rasht Airport", ctmCodeStr: "73" },
  { ctmVCodeInt: 20500, ctmNameStr: "Incheh Borun", ctmCodeStr: "100" },
  { ctmVCodeInt: 20501, ctmNameStr: "Bandar Torkaman", ctmCodeStr: "104" },
  { ctmVCodeInt: 20502, ctmNameStr: "Gorgan", ctmCodeStr: "198" },
  { ctmVCodeInt: 20503, ctmNameStr: "Gonbad-e Kavus", ctmCodeStr: "122" },
  { ctmVCodeInt: 20600, ctmNameStr: "Anzali", ctmCodeStr: "0" },
  {
    ctmVCodeInt: 20601,
    ctmNameStr: "Hassan Rud Anzali Free Trade Zone",
    ctmCodeStr: "156",
  },
  { ctmVCodeInt: 25100, ctmNameStr: "Tabriz", ctmCodeStr: "35" },
  { ctmVCodeInt: 25101, ctmNameStr: "Tabriz Airport", ctmCodeStr: "0" },
  { ctmVCodeInt: 25102, ctmNameStr: "Bonab", ctmCodeStr: "0" },
  {
    ctmVCodeInt: 25200,
    ctmNameStr: "Sahlan Special Economic Zone",
    ctmCodeStr: "143",
  },
  { ctmVCodeInt: 25205, ctmNameStr: "Khoda Afarin", ctmCodeStr: "149" },
  { ctmVCodeInt: 25300, ctmNameStr: "Jolfa", ctmCodeStr: "117" },
  { ctmVCodeInt: 25302, ctmNameStr: "Norduz", ctmCodeStr: "137" },
  { ctmVCodeInt: 25303, ctmNameStr: "Norduz Bazaar", ctmCodeStr: "94" },
  { ctmVCodeInt: 25304, ctmNameStr: "Jolfa Free Trade Zone", ctmCodeStr: "4" },
  { ctmVCodeInt: 25400, ctmNameStr: "Ardabil", ctmCodeStr: "11" },
  { ctmVCodeInt: 25401, ctmNameStr: "Bileh Savar", ctmCodeStr: "174" },
  { ctmVCodeInt: 25500, ctmNameStr: "Maragheh", ctmCodeStr: "29" },
  { ctmVCodeInt: 30100, ctmNameStr: "Bazargan", ctmCodeStr: "85" },
  { ctmVCodeInt: 30101, ctmNameStr: "Paldasht", ctmCodeStr: "12" },
  { ctmVCodeInt: 30102, ctmNameStr: "Sari Su Bazaar", ctmCodeStr: "127" },
  { ctmVCodeInt: 30200, ctmNameStr: "Urmia", ctmCodeStr: "173" },
  { ctmVCodeInt: 30201, ctmNameStr: "Mahabad", ctmCodeStr: "128" },
  {
    ctmVCodeInt: 30202,
    ctmNameStr: "Piranshahr-Temarchin Bazaar",
    ctmCodeStr: "142",
  },
  { ctmVCodeInt: 30203, ctmNameStr: "Khoy", ctmCodeStr: "138" },
  { ctmVCodeInt: 30204, ctmNameStr: "Razi-Khoy Bazaar", ctmCodeStr: "179" },
  { ctmVCodeInt: 30205, ctmNameStr: "Sardasht", ctmCodeStr: "111" },
  {
    ctmVCodeInt: 30206,
    ctmNameStr: "Kileh Sardasht Bazaar",
    ctmCodeStr: "185",
  },
  { ctmVCodeInt: 30207, ctmNameStr: "Piranshahr Temarchin", ctmCodeStr: "171" },
  { ctmVCodeInt: 30209, ctmNameStr: "Maku Free Trade Zone", ctmCodeStr: "89" },
  { ctmVCodeInt: 30300, ctmNameStr: "Sarv", ctmCodeStr: "167" },
  { ctmVCodeInt: 30301, ctmNameStr: "Sarv Bazaar", ctmCodeStr: "147" },
  { ctmVCodeInt: 30302, ctmNameStr: "Razi", ctmCodeStr: "152" },
  { ctmVCodeInt: 30303, ctmNameStr: "Sanam Balaghi Bazaar", ctmCodeStr: "110" },
  { ctmVCodeInt: 35100, ctmNameStr: "Kermanshah", ctmCodeStr: "43" },
  { ctmVCodeInt: 35101, ctmNameStr: "Paveh", ctmCodeStr: "90" },
  { ctmVCodeInt: 35102, ctmNameStr: "Shoushmi Bazaar", ctmCodeStr: "18" },
  { ctmVCodeInt: 35104, ctmNameStr: "Mehran", ctmCodeStr: "33" },
  { ctmVCodeInt: 35105, ctmNameStr: "Sheikh Salleh", ctmCodeStr: "47" },
  {
    ctmVCodeInt: 35107,
    ctmNameStr: "Islamabad West Special Zone",
    ctmCodeStr: "0",
  },
  { ctmVCodeInt: 35200, ctmNameStr: "Khosravi", ctmCodeStr: "9" },
  { ctmVCodeInt: 35201, ctmNameStr: "Parviz Khan Bazaar", ctmCodeStr: "199" },
  { ctmVCodeInt: 35202, ctmNameStr: "Soomar", ctmCodeStr: "0" },
  { ctmVCodeInt: 35300, ctmNameStr: "Sanandaj", ctmCodeStr: "41" },
  { ctmVCodeInt: 35301, ctmNameStr: "Marivan", ctmCodeStr: "10" },
  { ctmVCodeInt: 35303, ctmNameStr: "Baneh", ctmCodeStr: "101" },
  { ctmVCodeInt: 35304, ctmNameStr: "Siryanband Bazaar", ctmCodeStr: "115" },
  { ctmVCodeInt: 35305, ctmNameStr: "Saif Saqez Bazaar", ctmCodeStr: "88" },
  { ctmVCodeInt: 35306, ctmNameStr: "Bashmaq", ctmCodeStr: "48" },
  { ctmVCodeInt: 35400, ctmNameStr: "Qasr Shirin", ctmCodeStr: "84" },
  { ctmVCodeInt: 35500, ctmNameStr: "Parviz Khan", ctmCodeStr: "46" },
  { ctmVCodeInt: 40100, ctmNameStr: "Ahvaz", ctmCodeStr: "27" },
  {
    ctmVCodeInt: 40102,
    ctmNameStr: "Chazhabeh - Marzbanestan",
    ctmCodeStr: "135",
  },
  { ctmVCodeInt: 40200, ctmNameStr: "Khorramshahr", ctmCodeStr: "169" },
  { ctmVCodeInt: 40201, ctmNameStr: "Shalamcheh", ctmCodeStr: "187" },
  {
    ctmVCodeInt: 40202,
    ctmNameStr: "Arvand Free Trade Zone Khorramshahr",
    ctmCodeStr: "183",
  },
  { ctmVCodeInt: 40302, ctmNameStr: "Arvandkenar", ctmCodeStr: "157" },
  { ctmVCodeInt: 40303, ctmNameStr: "Chouebdeh", ctmCodeStr: "130" },
  { ctmVCodeInt: 40305, ctmNameStr: "Abadan Bazaar", ctmCodeStr: "44" },
  {
    ctmVCodeInt: 40306,
    ctmNameStr: "Arvand Free Trade Zone - Abadan",
    ctmCodeStr: "105",
  },
  {
    ctmVCodeInt: 40400,
    ctmNameStr: "Imam Khomeini Port Special Economic Zone",
    ctmCodeStr: "195",
  },
  {
    ctmVCodeInt: 40401,
    ctmNameStr: "Imam Khomeini Port Petrochemical Special Economic Zone",
    ctmCodeStr: "189",
  },
  { ctmVCodeInt: 40402, ctmNameStr: "Sejafi", ctmCodeStr: "145" },
  { ctmVCodeInt: 40403, ctmNameStr: "Mahshahr", ctmCodeStr: "50" },
  { ctmVCodeInt: 40404, ctmNameStr: "Hendijan", ctmCodeStr: "79" },
  {
    ctmVCodeInt: 45100,
    ctmNameStr: "Bushehr Special Economic Zone 1",
    ctmCodeStr: "74",
  },
  { ctmVCodeInt: 45103, ctmNameStr: "Khark", ctmCodeStr: "114" },
  { ctmVCodeInt: 45104, ctmNameStr: "Delvar", ctmCodeStr: "51" },
  { ctmVCodeInt: 45105, ctmNameStr: "Boo Alkhair", ctmCodeStr: "136" },
  { ctmVCodeInt: 45106, ctmNameStr: "Kangan", ctmCodeStr: "83" },
  { ctmVCodeInt: 45107, ctmNameStr: "Deyr", ctmCodeStr: "80" },
  { ctmVCodeInt: 45109, ctmNameStr: "Nakhl Taqi - Bushehr", ctmCodeStr: "25" },
  {
    ctmVCodeInt: 45110,
    ctmNameStr: "Bushehr Special Economic Zone 2",
    ctmCodeStr: "0",
  },
  { ctmVCodeInt: 45113, ctmNameStr: "Laver", ctmCodeStr: "160" },
  { ctmVCodeInt: 45114, ctmNameStr: "Lar Airport", ctmCodeStr: "57" },
  {
    ctmVCodeInt: 45115,
    ctmNameStr: "Lamerd Special Economic Zone",
    ctmCodeStr: "68",
  },
  { ctmVCodeInt: 45200, ctmNameStr: "Genaveh", ctmCodeStr: "141" },
  { ctmVCodeInt: 45201, ctmNameStr: "Deylam", ctmCodeStr: "193" },
  { ctmVCodeInt: 45202, ctmNameStr: "Bandar Rig", ctmCodeStr: "177" },
  { ctmVCodeInt: 45300, ctmNameStr: "Shiraz", ctmCodeStr: "6" },
  {
    ctmVCodeInt: 45301,
    ctmNameStr: "Shiraz Special Economic Zone",
    ctmCodeStr: "162",
  },
  { ctmVCodeInt: 45302, ctmNameStr: "Shiraz Airport", ctmCodeStr: "106" },
  { ctmVCodeInt: 45303, ctmNameStr: "Lar Airport", ctmCodeStr: "45114" },
  {
    ctmVCodeInt: 45304,
    ctmNameStr: "Kazeroon Special Economic Zone",
    ctmCodeStr: "0",
  },
  {
    ctmVCodeInt: 45305,
    ctmNameStr: "Jahrom Special Economic Zone",
    ctmCodeStr: "200",
  },
  {
    ctmVCodeInt: 45400,
    ctmNameStr: "Pars Energy Special Economic Zone",
    ctmCodeStr: "13",
  },
  {
    ctmVCodeInt: 50100,
    ctmNameStr: "Shaheed Rajaei Special Economic Zone",
    ctmCodeStr: "166",
  },
  {
    ctmVCodeInt: 50101,
    ctmNameStr: "Persian Gulf Shipbuilding",
    ctmCodeStr: "2",
  },
  {
    ctmVCodeInt: 50102,
    ctmNameStr: "Qeshm Free Trade Zone",
    ctmCodeStr: "180",
  },
  { ctmVCodeInt: 50104, ctmNameStr: "Hormuz", ctmCodeStr: "28" },
  { ctmVCodeInt: 50105, ctmNameStr: "Tiyab", ctmCodeStr: "164" },
  { ctmVCodeInt: 50106, ctmNameStr: "Kargan", ctmCodeStr: "62" },
  { ctmVCodeInt: 50107, ctmNameStr: "Sirik", ctmCodeStr: "52" },
  { ctmVCodeInt: 50108, ctmNameStr: "Khamir", ctmCodeStr: "107" },
  { ctmVCodeInt: 50109, ctmNameStr: "Pahl", ctmCodeStr: "188" },
  { ctmVCodeInt: 50200, ctmNameStr: "Shaheed Bahonar", ctmCodeStr: "194" },
  { ctmVCodeInt: 50203, ctmNameStr: "Laft", ctmCodeStr: "150" },
  { ctmVCodeInt: 50300, ctmNameStr: "Bandar Lengeh", ctmCodeStr: "190" },
  { ctmVCodeInt: 50301, ctmNameStr: "Kang", ctmCodeStr: "81" },
  { ctmVCodeInt: 50302, ctmNameStr: "Chark", ctmCodeStr: "17" },
  { ctmVCodeInt: 50303, ctmNameStr: "Lavan", ctmCodeStr: "144" },
  { ctmVCodeInt: 50304, ctmNameStr: "Shiv", ctmCodeStr: "7" },
  { ctmVCodeInt: 50305, ctmNameStr: "Siri", ctmCodeStr: "56" },
  {
    ctmVCodeInt: 50307,
    ctmNameStr: "Lavan Special Economic Zone",
    ctmCodeStr: "0",
  },
  {
    ctmVCodeInt: 50308,
    ctmNameStr: "Parsian Energy Special Economic Zone",
    ctmCodeStr: "50308",
  },
  { ctmVCodeInt: 50400, ctmNameStr: "Kish Free Trade Zone", ctmCodeStr: "176" },
  { ctmVCodeInt: 50500, ctmNameStr: "Jask", ctmCodeStr: "172" },
  { ctmVCodeInt: 50600, ctmNameStr: "Kerman", ctmCodeStr: "37" },
  {
    ctmVCodeInt: 50601,
    ctmNameStr: "Rafsanjan Special Economic Zone",
    ctmCodeStr: "63",
  },
  {
    ctmVCodeInt: 50602,
    ctmNameStr: "Sirjan Special Economic Zone",
    ctmCodeStr: "121",
  },
  { ctmVCodeInt: 50603, ctmNameStr: "Yazd", ctmCodeStr: "95" },
  { ctmVCodeInt: 50604, ctmNameStr: "Bam", ctmCodeStr: "45" },
  {
    ctmVCodeInt: 50605,
    ctmNameStr: "Bam Special Economic Zone",
    ctmCodeStr: "113",
  },
  { ctmVCodeInt: 50700, ctmNameStr: "Shaheed Rajaei", ctmCodeStr: "129" },
  {
    ctmVCodeInt: 50800,
    ctmNameStr: "Persian Gulf Mineral and Metal Industries Special Zone",
    ctmCodeStr: "59",
  },
  {
    ctmVCodeInt: 50901,
    ctmNameStr: "Yazd Special Economic Zone",
    ctmCodeStr: "0",
  },
  { ctmVCodeInt: 55100, ctmNameStr: "Zahedan", ctmCodeStr: "108" },
  { ctmVCodeInt: 55101, ctmNameStr: "Iranshahr", ctmCodeStr: "112" },
  { ctmVCodeInt: 55102, ctmNameStr: "Saravan", ctmCodeStr: "186" },
  { ctmVCodeInt: 55103, ctmNameStr: "Milk Bazaar", ctmCodeStr: "42" },
  { ctmVCodeInt: 55104, ctmNameStr: "Zabol", ctmCodeStr: "87" },
  { ctmVCodeInt: 55105, ctmNameStr: "Milk", ctmCodeStr: "168" },
  { ctmVCodeInt: 55106, ctmNameStr: "Mirjaveh Bazaar", ctmCodeStr: "1" },
  { ctmVCodeInt: 55107, ctmNameStr: "Kuhak-Saravan Bazaar", ctmCodeStr: "154" },
  {
    ctmVCodeInt: 55108,
    ctmNameStr: "Chabahar Free Trade Zone",
    ctmCodeStr: "32",
  },
  { ctmVCodeInt: 55110, ctmNameStr: "Jaleq Border Bazaar", ctmCodeStr: "70" },
  { ctmVCodeInt: 55111, ctmNameStr: "Gomshad Border Bazaar", ctmCodeStr: "31" },
  {
    ctmVCodeInt: 55112,
    ctmNameStr: "Rimadan Border Bazaar",
    ctmCodeStr: "118",
  },
  { ctmVCodeInt: 55200, ctmNameStr: "Mirjaveh", ctmCodeStr: "71" },
  { ctmVCodeInt: 55300, ctmNameStr: "Chabahar", ctmCodeStr: "178" },
  { ctmVCodeInt: 55301, ctmNameStr: "Pishin", ctmCodeStr: "0" },
  { ctmVCodeInt: 55303, ctmNameStr: "Kenarak", ctmCodeStr: "38" },
  { ctmVCodeInt: 55304, ctmNameStr: "Pishin Bazaar", ctmCodeStr: "191" },
  { ctmVCodeInt: 60100, ctmNameStr: "Mashhad", ctmCodeStr: "96" },
  { ctmVCodeInt: 60101, ctmNameStr: "Mashhad (Sepad)", ctmCodeStr: "16" },
  { ctmVCodeInt: 60200, ctmNameStr: "Sarakhs", ctmCodeStr: "158" },
  {
    ctmVCodeInt: 60201,
    ctmNameStr: "Sarakhs Special Economic Zone",
    ctmCodeStr: "0",
  },
  { ctmVCodeInt: 60300, ctmNameStr: "Bajgiran", ctmCodeStr: "69" },
  { ctmVCodeInt: 60301, ctmNameStr: "Bajgiran Bazaar", ctmCodeStr: "93" },
  { ctmVCodeInt: 60302, ctmNameStr: "Yazdan Bazaar", ctmCodeStr: "86" },
  { ctmVCodeInt: 60400, ctmNameStr: "Lotfabad", ctmCodeStr: "181" },
  { ctmVCodeInt: 60500, ctmNameStr: "Dogharun", ctmCodeStr: "82" },
  { ctmVCodeInt: 60501, ctmNameStr: "Golorde Bazaar", ctmCodeStr: "131" },
  { ctmVCodeInt: 60502, ctmNameStr: "Dogharun Bazaar", ctmCodeStr: "170" },
  { ctmVCodeInt: 60503, ctmNameStr: "Dogharun Special Zone", ctmCodeStr: "0" },
  { ctmVCodeInt: 60600, ctmNameStr: "Birjand", ctmCodeStr: "23" },
  { ctmVCodeInt: 60601, ctmNameStr: "Dokuhane Bazaar", ctmCodeStr: "103" },
  { ctmVCodeInt: 60602, ctmNameStr: "Mil 75 Bazaar", ctmCodeStr: "58" },
  { ctmVCodeInt: 60603, ctmNameStr: "Mahirud Bazaar", ctmCodeStr: "116" },
  { ctmVCodeInt: 60604, ctmNameStr: "Mahirud - Mil 78", ctmCodeStr: "53" },
  { ctmVCodeInt: 60700, ctmNameStr: "Bojnurd", ctmCodeStr: "99" },
  { ctmVCodeInt: 60800, ctmNameStr: "Jajarm", ctmCodeStr: "0" },
  { ctmVCodeInt: 70100, ctmNameStr: "Ilam", ctmCodeStr: "161" },
  { ctmVCodeInt: 70201, ctmNameStr: "Mehran Bazaar", ctmCodeStr: "153" },
  { ctmVCodeInt: 80100, ctmNameStr: "Zanjan", ctmCodeStr: "61" },
  { ctmVCodeInt: 90100, ctmNameStr: "Qom", ctmCodeStr: "159" },
  {
    ctmVCodeInt: 90101,
    ctmNameStr: "Salafchegan Special Economic Zone",
    ctmCodeStr: "78",
  },
  { ctmVCodeInt: 99999, ctmNameStr: "Arka Test", ctmCodeStr: "12504" },
];
